// link.js
// Shared helpers for link handling

// Basic URL matcher for common URL schemes and bare www.*; avoids whitespace/newlines
export const urlRegex = /^(https?:\/\/[^\s]+|mailto:[^\s]+|tel:[^\s]+|www\.[^\s]+)$/i;

export function normalizeUrl(raw) {
    if (!raw) return null;
    // Strip trailing punctuation that often lands inside clipboard text by accident.
    // e.g. "Visit https://example.com." → "https://example.com"
    const trimmed = raw.trim().replace(/[.,;:!?)'"]+$/, "");
    if (!urlRegex.test(trimmed)) return null;
    // Prepend https:// when user enters bare www.*
    if (/^www\./i.test(trimmed)) {
        return `https://${trimmed}`;
    }
    return trimmed;
}

export function getLinkAttrsAtSelection(state) {
    const link = state.schema.marks.link;
    if (!link) return null;
    const {$from, empty, from, to} = state.selection;
    if (empty) {
        const mark = link.isInSet(state.storedMarks || $from.marks());
        return mark ? mark.attrs : null;
    }
    let attrs = null;
    state.doc.nodesBetween(from, to, (node) => {
        if (attrs || !node.isText) return;
        const mark = link.isInSet(node.marks);
        if (mark) attrs = mark.attrs;
    });
    return attrs;
}
